import { Checkbox } from 'primereact/checkbox';
import { FC, useEffect, useState } from 'react';

interface Props {
  onlyTarget: boolean;
}

export const AssignmentSidebarModalInfo: FC<Props> = ({ onlyTarget }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  useEffect(() => {
    if (dontShowAgain) {
      localStorage.setItem(`NOT_SHOW_CREATE_ASSIGNMENT_INFO_${onlyTarget ? 'TARGET' : 'PATH'}`, 'Y');
    } else {
      localStorage.removeItem(`NOT_SHOW_CREATE_ASSIGNMENT_INFO_${onlyTarget ? 'TARGET' : 'PATH'}`);
    }
  }, [dontShowAgain]);
  return (
    <div className="assignment-info-content">
      <h4 className="font-bold">Assign a Skill {!onlyTarget ? 'Pathway' : ''}: How Student Groups Work</h4>
      <p>To help you target instruction effectively, students are automatically grouped based on their progress:</p>
      <SectionsInfo onlyTarget={onlyTarget} />
      {onlyTarget && (
        <div>
          <p>
            {`When you assign a skill, it will be assigned to the selected students regardless of the groups they're in.
            This information is provided to help you make an informed choice about the skill you're assigning and
            whether it's a good fit for the students based on their progress.`}
          </p>
        </div>
      )}
      <Checkbox
        className="mt-2"
        id="dont-show-again-assignment-info"
        checked={dontShowAgain}
        onChange={() => {
          setDontShowAgain(!dontShowAgain);
        }}
      />
      <label htmlFor="dont-show-again-assignment-info">{`Don't show this again`}</label>
    </div>
  );
};

export const SectionsInfo: FC<{ onlyTarget: boolean }> = ({ onlyTarget }) => {
  return (
    <div className="p-3 border-round">
      <div>
        <span className="font-semibold">On Track: </span>
        <span>
          Students have completed all support skills and are prepared for the target skill. They will only be assigned
          the target skill.
        </span>
      </div>
      <div className="mt-3">
        <span className="font-semibold">Paving the Way: </span>
        <span>Students have not completed all support skills but can still receive the target skill.</span>
        {!onlyTarget && (
          <span> They will be assigned both the missing essential support skills and the target skill.</span>
        )}
      </div>
      <div className="mt-3">
        <span className="font-semibold">Already Passed: </span>
        <span>
          These students have already passed the target skill. You may choose to assign it again for review or
          reinforcement.
        </span>
      </div>
    </div>
  );
};
